
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    modelColor: {
      get: function get() {
        return this.color;
      },
      set: function set(val) {
        this.$emit('inputColor', val);
      }
    }
  }
};